import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateDiscordPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.updateDiscordPerk,
  {
    mutationKey: ['updateDiscordPerk'],
  },
)
